
export class Claus {
    id: string;
    cuitNumbers: string[];
}
